import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';

const Description = styled('article')`
  line-height: 25px;
`;

export const SectionHeading = styled('h3')`
  ${({ theme }) => theme.typography.h3};
  margin-bottom: 1rem;
`;

export const ProductSection = styled('section')`
  margin-right: ${({ theme }) => theme.space[4]};
  margin-left: ${({ theme }) => theme.space[4]};
  width: 100%;
  padding-bottom: 3rem;
  position: relative;

  ${({ theme }) => theme.above.md} {
    width: ${({ theme }) =>
      //`calc(52% - ${theme.space[4]} - ${theme.space[4]})`};
      `calc(46% - ${theme.space[4]} - ${theme.space[4]})`};
    }
    &:nth-of-type(2) {
      width: ${({ theme }) =>
        //`calc(48% - ${theme.space[4]} - ${theme.space[4]})`};
        `calc(54% - ${theme.space[4]} - ${theme.space[4]})`};
      }
    }
    ${({ theme }) => theme.below.md} {
      margin: 0;
      width: 100% !important;
      padding-bottom: 1.5rem;
    }
    div[class*="image-gallery-slide-wrapper"] {
      & > span, & > button {
        display: none;
      }
    }
`;

const ProductSectionInfoBlock = styled(ProductSection)`
  background: white;
  max-width: 606px;
  padding: 1.75rem;
  ${({ theme }) => theme.below.md} {
    padding: 1rem;
  }

  table,
  tbody,
  tr,
  th,
  td {
    display: block;
    font-size: 0.9rem;
  }
  tr {
    th {
      font-weight: bold !important;
      line-height: 1rem;
    }
    &:first-of-type {
      th {
        margin-top: 0;
      }
    }
  }
  td {
    line-height: 1.45rem !important;
  }
  th {
    text-transform: uppercase;
    margin-top: 0.75rem;
    //margin-bottom: 0.5rem;
  }
`;

const BreakFlex = styled('div')`
  flex: 1 1 100%;
  width: 100%;

  div[class*='SectionRow'] {
    & > div[class*='SectionRowInner'] {
      & > section[class*='ProductSection'] {
        flex: 1 1 auto;
      }
    }
  }
`;

const SectionRow = styled('div')`
  ${({ theme }) => theme.elements.fwContainer};
  background: ${({ theme }) => theme.colors.grey};
  padding: 2.75rem 0;
  ${({ theme }) => theme.below.md} {
    padding: 1.5rem 0;
  }
`;

const SectionRowInner = styled('div')`
  ${({ theme }) => theme.elements.container};
  display: flex;
  flex-wrap: wrap;
`;

// & > div[class*="Wrapper"] {
//   height: 100%;
//   & > div[class*="Wrapper"] {
//       height: 100%;
//       & > div[class*="image-gallery"] {
//           height: 100%;
//           & > div[class*="image-gallery-content"] {
//             display: flex;
//             justify-content: space-between;
//             height: 100%;
//             & > div[class*="image-gallery-slide-wrapper"] {
//
//             }
//           }
//       }
//   }
// }

//<SectionHeading>{t('Specifications')}</SectionHeading>
const ProductInfo = ({ product }) => {
  return (
    <BreakFlex>
      <SectionRow>
        <SectionRowInner>
          <ProductSection>
            <SectionHeading>{t('Product description')}</SectionHeading>
            <Description
              dangerouslySetInnerHTML={{
                __html: product.description
              }}
            />
          </ProductSection>
          {product.customFields.length > 0 && (
            <ProductSectionInfoBlock>
              <ProductSpecifications fields={product.customFields} />
            </ProductSectionInfoBlock>
          )}
        </SectionRowInner>
      </SectionRow>
    </BreakFlex>
  );
};

export default ProductInfo;
